import { resto } from '@saucelabs/sl-util-axios';

/**
 * @param {string} username
 * @param {Object} params
 * @param {number} params.limit
 */
export function getOrganization(username, params = {}) {
  return resto.get(
    `/rest/v1.1/users/${username}/organization`,
    {
      params: { limit: 100, ...params },
    },
  );
}
